import React, { useCallback, useEffect, useState } from "react";
import api from "../../../api";
import { Divider, Input, Select, Space, Table } from "antd";
import dayjs from "dayjs";
import { formatCurrency } from "../../../utilities/utils";
import { useToast } from "../../../components/toast/toast";

const AccountStatement = () => {
  const [statements, setStatements] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    account_number: "",
    related_account: "",
    description: "",
  });
  const [bankList, setBankList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const toast = useToast();

  const fetchStatements = useCallback(async (params) => {
    setIsLoading(true);
    const res = await api.get_all_bank_statements(params);
    // console.log("res --->", res);
    if (res.status === 200) {
      setStatements(res.data.data);
      setTotal(res.data.total);
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
  }, []);

  const fetchBank = async () => {
    const res = await api.get_bank_list();
    // console.log("bankData --->", res);
    if (res.status === 200) {
      setBankList(res.data.data);
    }
  };

  useEffect(() => {
    fetchBank();
  }, []);

  // Анх болон page/filter өөрчлөгдөхөд татна
  const onFilterChange = (key) => (e) => {
    const value = e.target.value;
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    setPage(1); // Шинэ filter → хуудас 1-рүү буцаах
  };

  // Анх болон page, pageSize, filters өөрчлөгдөхөд дуудаж байна
  useEffect(() => {
    fetchStatements({
      page,
      limit: pageSize,
      ...filters,
    });
  }, [fetchStatements, page, pageSize, filters]);

  const columns = [
    { title: "Record ID", dataIndex: "record_id", key: "record_id" },
    {
      title: "Дансны дугаар",
      dataIndex: "account_number",
      key: "account_number",
    },
    {
      title: "Гүйлгээний дүн",
      dataIndex: "amount",
      key: "amount",
      render: (val) => formatCurrency(val),
    },
    { title: "Гүйлгээний утга", dataIndex: "description", key: "description" },
    {
      title: "Хэрэглэгчийн данс",
      dataIndex: ["raw_data", "relatedAccount"],
      key: "relatedAccount",
      render: (val) => val || "-",
    },
    {
      title: "Гүйлгээ хийсэн цаг",
      key: "dateTime",
      render: (_, record) => {
        const { tranDate, time } = record.raw_data;

        if (time == null) {
          return tranDate || "-";
        }
        // Хэрвээ тасархай 8 тэмдэгтгүй бол зүүн талд нь тэг нэмнэ
        const t = time?.toString().padStart(8, "0");
        const hh = t?.slice(0, 2);
        const mm = t?.slice(2, 4);
        const ss = t?.slice(4, 6);
        // ISO форматын дата үүсгэх (JS-д тохируулсан хугацаатай)
        const iso = `${tranDate}T${hh}:${mm}:${ss}`;
        // dayjs-д хөрвүүлээд форматлана
        return dayjs(iso).format("YYYY-MM-DD HH:mm:ss");
      },
    },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Select
          style={{ width: 200, minHeight: "40px" }}
          allowClear
          options={bankList.map((item) => ({
            value: item.account_number,
            label: `${item.bank} - ${item.account_number}`,
          }))}
          placeholder="Дансны дугаар"
          //   value={filters.account_number}
          onChange={(value) => {
            setFilters({ ...filters, account_number: value });
            // fetchStatements({ ...filters, account_number: value });
            setPage(1);
          }}
        />
        <Divider type="vertical" />
        <Input
          style={{ width: 200, minHeight: "40px" }}
          placeholder="Холбогдох данс"
          value={filters.related_account}
          onChange={onFilterChange("related_account")}
          allowClear
        />
        <Divider type="vertical" />
        <Input
          style={{ width: 200, minHeight: "40px" }}
          placeholder="Гүйлгээний утга"
          value={filters.description}
          onChange={onFilterChange("description")}
          allowClear
        />
      </Space>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={statements}
        loading={isLoading}
        pagination={{
          current: page,
          pageSize,
          total,
          showSizeChanger: true,
        }}
        onChange={({ current, pageSize: newSize }) => {
          setPage(current);
          setPageSize(newSize);
        }}
      />
    </div>
  );
};

export default AccountStatement;
